import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';

const REPORT_WIDTH = 32;
const REPORT_HEIGHT = 36;
const reportHeightGridUnits = REPORT_HEIGHT / 2;
export const IMAGE_WIDTH = gridSize * REPORT_WIDTH;
export const IMAGE_HEIGHT = gridSize * reportHeightGridUnits;

export const CYCLE_TIME_REPORT_KEY = 'jsw.report.cycle-time';
export const CI_CD_GET_STARTED_LINK =
	'https://www.atlassian.com/software/jira/guides/developers/ci-cd#get-started';
